import { useQuery } from '@hooks/reactQuery';

import { getHistoryCheckAwtgRanNetworkElements } from '@api/hitoryCheck';

import { IAwtgRanNetworkElement } from '@interfaces/cmModule/cmModule';
import { IModalSelectOption } from '@components/common/ModalSelect/ModalSelect.types';

import { EUserRoles, EVendorsValues } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { HISTORY_CHECK_AWTG_RAN_NETWORK_ELEMENTS } from '@constants/queryKeys';

interface UseQueryHistoryCheckAwtgRanNetworkElementsParams {
	vendor?: string;
	configType?: string;
	isAwtgRanVendor?: boolean;
}

export const useQueryHistoryCheckAwtgRanNetworkElements = ({
	vendor,
	configType,
}: UseQueryHistoryCheckAwtgRanNetworkElementsParams) => {
	const {
		data,
		isInitialLoading,
	} = useQuery<IAwtgRanNetworkElement[], IModalSelectOption[]>({
		queryKey: [HISTORY_CHECK_AWTG_RAN_NETWORK_ELEMENTS, vendor, configType],
		queryFn: () => getHistoryCheckAwtgRanNetworkElements({ configType: configType! }),
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleViewer,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		select: (networkElements) => networkElements?.map((element) => ({
			value: element.id,
			label: element.name,
		})) || [],
		enabled: [vendor === EVendorsValues.oran, !!configType],
		...refetchOptions,
	});

	return {
		networkElementsOptions: data || [],
		isLoading: isInitialLoading,

	};
};
